import React, { useEffect, useState } from "react";
import { track } from "../utils/tracking";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("tracking_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (accepted) => {
    const consent = {
      marketing: accepted,
      timestamp: new Date().toISOString()
    };

    localStorage.setItem("tracking_consent", JSON.stringify(consent));

    if (accepted) {
      // 🔥 pedir ubicación
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;

          localStorage.setItem("lat_user", lat);
          localStorage.setItem("lon_user", lon);

          track("accept_cookies", {
            lat_user: lat,
            lon_user: lon
          });
        },
        () => {
          track("accept_cookies", {
            geo: "denied"
          });
        }
      );
    } else {
      track("reject_cookies");
    }

    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-overlay">
      <div className="cookie-modal">
        <h2>🍪 Uso de cookies</h2>

        <p>
          Usamos cookies para mejorar tu experiencia y analizar el uso del sitio.
          También podemos usar tu ubicación para personalizar contenido.
        </p>

        <div className="cookie-buttons">
          <button
            className="accept"
            onClick={() => handleChoice(true)}
          >
            Aceptar
          </button>

          <button
            className="reject"
            onClick={() => handleChoice(false)}
          >
            Rechazar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;